/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../components/auth/auth-constants';
import {ReportTemplateResource} from '../../components/api/resources/resource/report-template.resource';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-report-template-route-page',
  template: `
    <adn-report-template-list-page
      *ngIf="list"
      [list]="list">
    </adn-report-template-list-page>
  `
})
export class ReportTemplateRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(ReportTemplateResource) private readonly ReportTemplate: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasNetwork(PERMISSIONS.manageReportTemplates.apiKey);

    this.adnListHelper.setUpList(this.list, this.ReportTemplate, readOnly, 'fullReportTemplateList', {
      baseTable: 'reportTemplate'
    });
  }
}
